import { render, staticRenderFns } from "./salesTableFwhx.vue?vue&type=template&id=27bcea10"
import script from "./salesTableFwhx.vue?vue&type=script&lang=js"
export * from "./salesTableFwhx.vue?vue&type=script&lang=js"
import style0 from "./salesTableFwhx.vue?vue&type=style&index=0&id=27bcea10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports